import _ from 'root/libs/exaforte/react/lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from 'root/libs/exaforte/Defaults.less';

export default function(props)
{
    let new_props = {...props};
    
    if(!new_props.className)
        new_props.className = '';
    else if(_.isArray(new_props.className))
        new_props.className = new_props.className.join(' ');
    
    if(new_props.square !== false)
        new_props.className += ' ' + styles['fa-square'];

    delete new_props.square;
    
    return FontAwesomeIcon(new_props);
};